module.exports = __webpack_public_path__ + "assets/img/SM.6e68681b.png";